
/**
* @feat <>
import { catchError } from '@/utils/base/base.js'
*/

// import { message } from "antd";

export const manualStopNext = "手动终止";
export function catchError(e) {
  console.error(`捕获错误: ${location || ''}`, e)

  if (typeof e === 'object') {
    e = JSON.stringify(e)
  }
  if (new RegExp(manualStopNext).test(e)) {
    console.warn(manualStopNext);
    return;
  }

  alert(e)
}
